// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fb","advertDetailServiceList__header":"c-o_fc","advertDetailServiceList__list":"c-o_fe"};